import { t } from 'ttag';

export const extractDataError = (errors) => {
  const err = errors.filter((e) => e.field === 'data')[0];
  if (err && err.messages[0]) {
    const message = err.messages[0];
    if (message) {
      return message;
    }
  }
  return null;
};

export const ERROR_MESSAGES = {
  required: t`Обовязкове поле`,
};
